import React from 'react';
import { Box, Container, Typography, Grid, Link as MuiLink } from '@mui/material';
import UnrealVideoLogo from '../assets/UnrealVideoLogo.png';

const Footer: React.FC = () => {
  return (
    <Box component="footer" sx={{
      bgcolor: 'black',
      color: 'white',
      py: 8,
      px: 2,
      mt: 'auto',
      minHeight: '350px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    }}>
      <Container maxWidth="lg" sx={{ flex: 1 }}>
        <Grid container alignItems="flex-start" justifyContent="space-between" sx={{ minHeight: '220px' }}>
          {/* Left: Large Logo */}
          <Grid item xs={12} md={6} lg={5} sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', md: 'flex-start' } }}>
            <MuiLink href="https://unrealvideo.ai" underline="none" sx={{ display: 'inline-block' }}>
              <img
                src={UnrealVideoLogo}
                alt="UnrealVideo.ai"
                style={{
                  height: '60px',
                  width: 'auto',
                  objectFit: 'contain',
                  marginRight: 0,
                  marginLeft: 0,
                  display: 'block',
                }}
              />
            </MuiLink>
          </Grid>

          {/* Right: Links */}
          <Grid item xs={12} md={6} lg={4} 
            sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'flex-start', 
              justifyContent: 'center', 
              mt: { xs: 4, md: 0 }, 
              ml: { md: 8, lg: 12 }, 
              maxWidth: { xs: '100%', md: 260, lg: 300 }
            }}
          >
            <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, mb: 1.5, fontSize: '1.1rem', textAlign: 'left' }}>
              UnrealVideo.ai
            </Typography>
            <MuiLink href="https://www.unrealvideo.ai/about-us" color="#5A5CF6" underline="hover" sx={{ fontSize: '0.98rem', mb: 0.5, display: 'block', textAlign: 'left', whiteSpace: 'nowrap' }}>
              About Us
            </MuiLink>
            <MuiLink href="/scene-detection" color="#5A5CF6" underline="hover" sx={{ fontSize: '0.98rem', mb: 0.5, display: 'block', textAlign: 'left', whiteSpace: 'nowrap' }}>
              Scene Detector
            </MuiLink>
            <MuiLink href="/pricing" color="#5A5CF6" underline="hover" sx={{ fontSize: '0.98rem', mb: 0.5, display: 'block', textAlign: 'left', whiteSpace: 'nowrap' }}>
              Pricing
            </MuiLink>
            <MuiLink href="/contact" color="#5A5CF6" underline="hover" sx={{ fontSize: '0.98rem', display: 'block', textAlign: 'left', whiteSpace: 'nowrap' }}>
              Contact Us
            </MuiLink>
          </Grid>
        </Grid>

        {/* Bottom Center: Copyright */}
        <Box sx={{ mt: 8, textAlign: 'center' }}>
          <Typography variant="body2" color="rgba(255,255,255,0.8)" sx={{ fontSize: '0.95rem' }}>
            Copyright © 2025 UnrealVideo.ai is owned by Delivery Apps Now Inc.
          </Typography>
          <Typography variant="body2" color="rgba(255,255,255,0.8)" sx={{ mt: 0.5, fontSize: '0.95rem' }}>
            All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 